import { CircleLoader } from "react-spinners";

export const Fallback = () => (
  <div className="fixed inset-0 z-[1040] bg-black bg-opacity-50">
    <CircleLoader />
  </div>
);
